import CityLandingPage from './page';

const salvadorData = {
  cityName: 'Salvador',
  state: 'BA',
  slug: 'palestra-silenciosa-salvador',
  coordinates: {
    lat: -12.9714,
    lng: -38.5014,
  },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa salvador',
    'silent conference salvador',
    'aluguel fones sem fio salvador',
    'eventos corporativos salvador',
    'tradução simultânea salvador',
    'silent disco salvador',
  ],
  heroTitle: 'palestra silenciosa salvador',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências multilíngues e workshops em Salvador e Bahia. Palestra silenciosa com suporte técnico especializado.',
  localStats: {
    clients: '200+',
    satisfaction: '98%',
  },
  localTestimonials: [],
  localFAQs: [
    {
      question: 'A STIB atende eventos em Salvador e no interior da Bahia?',
      answer: 'Sim! Atendemos Salvador, Região Metropolitana e interior da Bahia. Para eventos em cidades como Feira de Santana, Vitória da Conquista e Ilhéus, entre em contato para verificar disponibilidade e condições de deslocamento.',
    },
    {
      question: 'Quais espaços de eventos em Salvador são compatíveis com palestra silenciosa?',
      answer: 'A palestra silenciosa funciona em qualquer espaço: Centro de Convenções da Bahia, Pestana Bahia, Sheraton da Bahia, espaços no Pelourinho, orla de Ondina e qualquer outro local. Não há restrições de ambiente.',
    },
    {
      question: 'Qual o prazo para contratar palestra silenciosa em Salvador?',
      answer: 'Recomendamos pelo menos 20 dias de antecedência para eventos em Salvador. Para eventos de grande porte, sugerimos 30 dias. Também atendemos demandas urgentes conforme disponibilidade.',
    },
    {
      question: 'A palestra silenciosa funciona para eventos ao ar livre em Salvador?',
      answer: 'Sim! Eventos na orla de Ondina, Barra, Porto da Barra e outros espaços ao ar livre em Salvador são casos de uso ideais. Sem caixas de som, sem poluição sonora, sem restrições de horário.',
    },
    {
      question: 'A STIB oferece silent disco para eventos culturais e carnavalescos em Salvador?',
      answer: 'Sim! O silent disco é perfeito para eventos culturais, pré-carnaval e festas em Salvador. Sem restrições de horário, sem barulho para vizinhos — ideal para eventos em espaços históricos do Pelourinho e orla.',
    },
  ],
  seoTitle: 'Palestra Silenciosa Salvador | Aluguel Fones Sem Fio BA | STIB',
  seoDescription: 'Palestra silenciosa Salvador: aluguel de fones sem fio para eventos corporativos, conferências e workshops na Bahia. Suporte técnico especializado, equipamentos premium. Orçamento: (11) 91777-6227.',
};

export default function SalvadorLandingPage() {
  return <CityLandingPage cityData={salvadorData} />;
}
